// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__3DDET","story-card":"styles-m__story-card__ratkl"};